import React, { useCallback, useState } from "react";
import { Background, ReactFlow, addEdge, ConnectionLineType, Panel, useNodesState, useEdgesState, MarkerType } from "@xyflow/react";
import dagre from "@dagrejs/dagre";

import "@xyflow/react/dist/style.css";
import { useQueryDependenciesGraphContext } from "../../context/questions-context";
// import { NarrativeTitle } from "@src/pages/intelligence-search-v2/components/query-narrative-text-vis";
import NarrativeTextNode from "./narrative-text-node"
import { Viewport } from "reactflow";

const nodeTypes = {
    narrativeTextNode: NarrativeTextNode

}

const position = { x: 0, y: 0 };
const edgeType = "smoothstep";
const baseEdge = {
    markerEnd: {
        type: MarkerType.Arrow,
        width: 20,
        height: 20,
        color: '#FF0072',
    },
    style: {
        strokeWidth: 2,
        stroke: '#FF0072',
    },
}

const dagreGraph = new dagre.graphlib.Graph().setDefaultEdgeLabel(() => ({}));

const nodeWidth = 400;
const nodeHeight = 400;

const getLayoutedElements = (nodes: any[], edges: any[], direction = "TB"): {nodes: any[], edges: any[]} => {
    const isHorizontal = direction === "LR";
    dagreGraph.setGraph({ rankdir: direction });

    nodes.forEach((node) => {
        dagreGraph.setNode(node.id, { width: nodeWidth, height: nodeHeight });
    });

    edges.forEach((edge) => {
        dagreGraph.setEdge(edge.source, edge.target);
    });

    dagre.layout(dagreGraph, {
        width: 400,
        height: 400,
        nodesep: 120
    });

    const newNodes = nodes.map((node) => {
        const nodeWithPosition = dagreGraph.node(node.id);
        const newNode = {
            ...node,
            targetPosition: isHorizontal ? "left" : "top",
            sourcePosition: isHorizontal ? "right" : "bottom",
            // We are shifting the dagre node position (anchor=center center) to the top left
            // so it matches the React Flow node anchor point (top left).
            position: {
                // x: nodeWithPosition.x - nodeWidth / 2,
                // x: nodeWithPosition.x - nodeWidth,
                x: nodeWithPosition.x,
                // y: nodeWithPosition.y - nodeHeight / 2,
                // y: nodeWithPosition.y - nodeHeight,
                y: nodeWithPosition.y,
            },
        };

        return newNode;
    });

    return { nodes: newNodes, edges };
};

export const DependenciesGraph = ({hidden = false}: {hidden?: boolean}) => {
    const [nodes, setNodes, onNodesChange] = useNodesState<any>([]);
    const [edges, setEdges, onEdgesChange] = useEdgesState<any>([]);
    const [viewPort, setViewPort] = useState<Viewport>()
    const { productCode, queries, dependenciesGraph } = useQueryDependenciesGraphContext()
    
    const initialNodes = Object.entries(queries || {}).map(([queryKey, queryDef]) => {
        return {
            id: queryKey,
            type: "narrativeTextNode",
            data: {
                // todo: custom label
                // label: <>
                //     <span>{queryDef.queryName}</span>
                //     {/* <NarrativeTitle
                //         query={queryDef.jsonQuery}
                //         productCode={""}
                //         // isLoading={false}
                //         // limit={queryLimitWatch}
                //     /> */}
                // </>,
                // label: queryDef.queryName,
                ...queryDef,
                productCode,
            },
            position
        }
    }) || []

    const initialEdges = Object.entries(dependenciesGraph || {}).flatMap(([queryKey1, dependencies]) => {
        return Object.entries(dependencies || {}).map(([queryKey2, assetName]) => {
            return { 
                ...baseEdge,
                id: `e${queryKey1}${queryKey2}`, 
                // source: queryKey1, 
                // target: queryKey2, 
                source: queryKey2, 
                target: queryKey1, 
                label: assetName,
            }
        })
    }) || []

    const { nodes: layoutedNodes, edges: layoutedEdges } = React.useMemo(() => {
        return getLayoutedElements(initialNodes, initialEdges)
    }, [JSON.stringify(initialNodes || {}), JSON.stringify(initialEdges || {})]);
    // }, [initialNodes, initialEdges]);


    // const onConnect = useCallback(
    //     (params) => setEdges((eds) => addEdge({ ...params, type: ConnectionLineType.SmoothStep, animated: true }, eds)),
    //     [],
    // );
    const onLayout = useCallback(
        (direction: "TB" | "LR") => {
            const { nodes: layoutedNodes, edges: layoutedEdges } = getLayoutedElements(nodes, edges, direction);

            setNodes([...layoutedNodes]);
            setEdges([...layoutedEdges]);
        },
        [nodes, edges],
    );

    React.useEffect(() => {
        setNodes(layoutedNodes)
        setEdges(layoutedEdges)
    }, [layoutedNodes, layoutedEdges, setNodes, setEdges])
    
    return (
            <ReactFlow
            nodes={nodes}
            edges={edges}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            connectionLineType={ConnectionLineType.SmoothStep}
            fitView
            onViewportChange={(v) => setViewPort(v)}
            viewport={viewPort}
            style={{ backgroundColor: "#F7F9FB" }}
            // className="h-[600px]"
            className="min-w-[1200px] w-[100%] h-[600px]"
            // className=""
            // width={}
            hidden={hidden}
            nodeTypes={nodeTypes}
        >
            <Panel position="top-right">
                <button className="xy-theme__button" onClick={() => setViewPort({x: 0, y:0, zoom: 0.5})}>
                    To Center
                </button>
                <button className="xy-theme__button" onClick={() => onLayout("TB")}>
                    Vertical layout
                </button>
                <button className="xy-theme__button" onClick={() => onLayout("LR")}>
                    Horizontal layout
                </button>
            </Panel>
            <Background />
        </ReactFlow>
    );
};
